<template>
	<Dialog :visible="true" style="width: 75rem; max-height: 80vh" modal :closable="false" :draggable="false">
		<template #header>
			<div class="w-full">
				<div class="flex justify-between">
					<h1>
						Select Assessment To Copy To {{ copyToAssessment ? "Existing " : "New " }} Assessment<FontAwesomeIcon
							:icon="['fa', 'spinner']"
							class="text-blue-500 mt-3 ml-2"
							spin
							v-show="props.spinnerRuns"
						/>
					</h1>
					<!-- <div class="flex gap-1">
						<Checkbox v-model="copyToAssessment" name="copyToAssessment" :binary="true" @change="onCopyAssessmentChange" />
						<label for="copyToAssessment" class="ml-2"> Copy to Assessment </label>
					</div> -->
					<div class="flex gap-2">
						<Button id="btnBackToPRList" v-if="!props.spinnerRuns" @click="emit('cancel')" :disabled="props.spinnerRuns" class="btn-tiny"
							>Cancel</Button
						>

						<!-- <button id="btnSaveProject" class="btn btn-primary" @click="save()" :disabled="props.spinnerRuns">Create Copy</button> -->
						<Button
							:style="{ opacity: props.spinnerRuns || arraysEqual(allAvailableTabs, screenToDisableInUIOnCopy) ? '0.6' : '1' }"
							@click="save"
							:disabled="props.spinnerRuns || arraysEqual(allAvailableTabs, screenToDisableInUIOnCopy)"
							class="btn-tiny"
						>
							<template #default>
								<span v-if="props.spinnerRuns">
									<FontAwesomeIcon :icon="['fa', 'spinner']" spin class="mr-2" />
									Copying...
								</span>
								<span v-else> Create Copy </span>
							</template>
						</Button>
					</div>
				</div>
				<div class="flex justify-end mt-6" v-show="copyToAssessment">
					<Checkbox v-model="moveToAssessment" inputId="moveToAssessment" :binary="true" />
					<label for="moveToAssessment" class="ml-2"> Open the target assessment when the copy is made </label>
				</div>
				<warningBlock :warning-messages="getWarnings()" class="my-2" />

				<I2FormRow v-if="selectedAssessmentId !== '' && !copyToAssessment">
					<I2FormField :label="'Assessment Name'">
						<InputText
							v-model="newAssessmentName"
							placeholder="select an assessment"
							:class="{ 'p-invalid': saveAttempted && !newAssessmentName, '': newAssessmentName !== '' }"
						/>
					</I2FormField>
					<I2FormField label="Development Stage">
						<Select
							ref="developmentStageDropdown"
							v-model="selectedDevelopmentStage"
							:options="developmentStageList"
							optionLabel="valueTxt"
							placeholder="Select a Development Stage"
							class="w-full md:w-14rem"
							:class="{ 'p-invalid': saveAttempted && (!selectedDevelopmentStage || !selectedDevelopmentStage.id) }"
							:filter="developmentStageList.length > 10"
						>
						</Select>
					</I2FormField>
				</I2FormRow>

				<div class="flex justify-between mt-4">
					<I2FormField :label="(copyToAssessment ? 'Source ' : '') + 'Project'" class="mr-6">
						<Select
							ref="projectDropdown"
							v-model="selectedProjectId"
							:options="projectList"
							optionLabel="projectName"
							option-value="id"
							placeholder="Select Project"
							class="w-full md:w-14rem"
							:filter="projectList.length > 0"
							@change="onProjectChange"
							:class="{ 'p-invalid': saveAttempted && !selectedProjectId, null: selectedProjectId !== null }"
							:disabled="loadingSelectionDefault"
						>
						</Select>
					</I2FormField>
					<I2FormField :label="(copyToAssessment ? 'Source ' : '') + 'Subproject'" class="mr-6">
						<Select
							ref="subProjectDropdown"
							v-model="selectedSubProjectId"
							:options="subProjectList"
							optionLabel="subProjectName"
							option-value="id"
							placeholder="Select Subproject"
							class="w-full md:w-14rem"
							:filter="subProjectList.length > 10"
							@change="onSubProjectChange"
							:class="{ 'p-invalid': saveAttempted && !selectedSubProjectId, null: selectedSubProjectId !== null }"
							:disabled="loadingSelectionDefault"
						>
							<template #value="slotProps">
								<div v-if="slotProps.value" class="flex align-items-center">
									<div>{{ getSelectedSubProjectName(slotProps.value) }}</div>
								</div>
								<span v-else>
									{{ slotProps.placeholder }}
								</span>
							</template>
							<template #option="slotProps">
								<div class="flex align-items-center">
									<div>
										{{ slotProps.option.subProjectName }} ({{
											slotProps.option.assessment.filter((item: any) => item.isActive === true && item.step.length > 0).length
										}})
									</div>
								</div>
							</template>
						</Select>
					</I2FormField>

					<I2FormField :label="(copyToAssessment ? 'Source ' : '') + 'Assessment'" class="mr-6">
						<Select
							ref="assessmentDropdown"
							v-model="selectedAssessmentId"
							:options="assessmentList"
							optionLabel="assessmentName"
							option-value="id"
							placeholder="Select Assessment"
							class="w-full md:w-14rem"
							:filter="assessmentList.length > 10"
							@change="onAssessmentChange"
							:class="{ 'p-invalid': saveAttempted && (!selectedAssessmentId || selectedAssessmentId.length == 0) }"
							:disabled="loadingDestSelectionDefault"
						>
						</Select>
					</I2FormField>
				</div>
				<div class="flex justify-between mt-4" v-if="copyToAssessment">
					<I2FormField label="Destination Project" class="mr-6">
						<Select
							ref="projectDestDropdown"
							v-model="selectedDestProjectId"
							:options="projectDestList"
							optionLabel="projectName"
							option-value="id"
							placeholder="Select Project"
							class="w-full md:w-14rem"
							:filter="projectDestList.length > 0"
							@change="onProjectDestChange"
							:class="{ 'p-invalid': saveAttempted && !selectedDestProjectId, null: selectedDestProjectId !== null && copyToAssessment }"
							:disabled="loadingDestSelectionDefault"
						>
						</Select>
					</I2FormField>
					<I2FormField label="Destination Subproject" class="mr-6">
						<Select
							ref="subProjectDestDropdown"
							v-model="selectedDestSubProjectId"
							:options="subProjectDestList"
							optionLabel="subProjectName"
							option-value="id"
							placeholder="Select Subproject"
							class="w-full md:w-14rem"
							:filter="subProjectDestList.length > 10"
							@change="onSubProjectDestChange"
							:class="{ 'p-invalid': saveAttempted && !selectedDestSubProjectId, null: selectedDestSubProjectId !== null && copyToAssessment }"
							:disabled="loadingDestSelectionDefault"
						>
							<template #value="slotProps">
								<div v-if="slotProps.value" class="flex align-items-center">
									<div>{{ getSelectedDestSubProjectName(slotProps.value) }}</div>
								</div>
								<span v-else>
									{{ slotProps.placeholder }}
								</span>
							</template>
							<template #option="slotProps">
								<div class="flex align-items-center">
									<div>
										{{ slotProps.option.subProjectName }} ({{
											slotProps.option.assessment.filter((item: any) => item.isActive === true && item.step.length > 0).length
										}})
									</div>
								</div>
							</template>
						</Select>
					</I2FormField>

					<I2FormField label="Destination Assessment" class="mr-6">
						<Select
							ref="assessmentDestDropdown"
							v-model="selectedDestAssessmentId"
							:options="assessmentDestList"
							optionLabel="assessmentName"
							option-value="id"
							placeholder="Select Assessment"
							class="w-full md:w-14rem"
							:filter="assessmentDestList.length > 10"
							@change="onAssessmentDestChange"
							:class="{ 'p-invalid': saveAttempted && !selectedDestAssessmentId, null: selectedDestAssessmentId !== null }"
							:disabled="loadingDestSelectionDefault"
						>
						</Select>
					</I2FormField>
				</div>

				<div class="overflow-y-auto" style="max-height: 30vh">
					<DataTable
						:value="allAvailableTabs"
						:selection="selectedScreen"
						@update:selection="updateSelection($event)"
						:row-style="getRowClass"
						responsiveLayout="scroll"
						:row-hover="true"
						dataKey="id"
						scrollable
						scrollHeight="flex"
						class="mt-4"
						selectionMode="multiple"
						:class="{ 'p-invalid': saveAttempted && !selectedScreen, null: selectedScreen !== null }"
						:loading="loadingSkillAreas"
					>
						<template #empty> No matching modules for the source data in target assessment. </template>
						<template #loading> Loading module data. Please wait. </template>

						<Column selectionMode="multiple" headerStyle="width: 20%"></Column>

						<Column field="screenName" headerStyle="width: 30%">
							<template #header><I2Label label="Module" helpElementName="CopyAssessmentDialogModule" /></template>
							<template #body="{ data }">
								<span v-tooltip="'This Module is already present in the target assessment.'" v-if="data.screenName.includes('(already present)')"
									><FontAwesomeIcon :icon="['fa', 'ban']" class="mr-2"
								/></span>
								<span v-tooltip="'This Module is already populated in the target assessment.'" v-if="data.screenName.includes('(already populated)')"
									><FontAwesomeIcon :icon="['fa', 'ban']" class="mr-2"
								/></span>
								<span v-if="data.screenName.includes('(not present in source)')" class="mr-2"
									><WarningIcon errorType="Warning" :tooltipText="['This Module is not present in the source assessment.']" size="sm"
								/></span>
								<span v-if="data.screenName.includes('(not present in dest)')" class="mr-2"
									><WarningIcon errorType="Warning" :tooltipText="['This Module is not present in the destination assessment.']" size="sm"
								/></span>
								<span>{{
									["already present", "not present in source", "can be added", "not present in dest"].reduce(
										(str, word) => str.replace(new RegExp(word, "g"), ""),
										data.screenName.replace(")", "").replace("(", "")
									)
								}}</span>
							</template>
						</Column>

						<Column headerStyle="width: 50%">
							<template #header><I2Label label="Progress" helpElementName="CopyAssessmentDialogProgress" /></template>
							<template #body="slotProps">
								<div style="width: 100%">
									<ProgressBar
										:value="screenP.find((item: screenPercentage) => item.screen.id === slotProps.data.id)?.percentage || 0"
										:style="{ width: '100%' }"
									/>
								</div>
							</template>
						</Column>
					</DataTable>
				</div>
			</div>
		</template>
	</Dialog>
</template>
<script setup lang="ts">
import I2Label from "@/crispify/crispy-components/I2Label.vue"
import { ref, onMounted, reactive, nextTick, watch } from "vue"
import {
	ApiClient,
	SubProject,
	Screen,
	Project,
	Step,
	Assessment,
	DevelopmentStage,
	SkillAreaStatus,
	MasterDropdown,
} from "../../entities/NSwagGenerated"
import { SessionInfo, PageAccess } from "../auth/personSessionData"

import Dialog from "primevue/dialog"
import InputText from "primevue/inputtext"
import ProgressBar from "primevue/progressbar"
import Checkbox from "primevue/checkbox"
import Button from "primevue/button"
import * as Session from "../auth/personSessionData"
import { useToast } from "primevue/usetoast"
import DataTable, { DataTableSelectAllChangeEvent } from "primevue/datatable"
import Column from "primevue/column"
import Dropdown, { DropdownChangeEvent } from "primevue/dropdown"
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { faTriangleExclamation, faSpinner, faBan } from "@fortawesome/free-solid-svg-icons"
library.add(faTriangleExclamation, faSpinner, faBan)
import WarningIcon from "./warningIcon.vue"
import { useToaster, SystemToastOptions } from "../composables/toaster"
import * as signalR from "@microsoft/signalr"
import { RowEmits } from "primevue/row"
import { da } from "date-fns/locale"
import { useErrorToaster } from "@/composables/toaster"
import { ErrorFormat } from "@/models/errorFormat"

const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())

const VITE_API_URL = import.meta.env.VITE_API_URL.toString()
let toast = useToast()
const props = defineProps({
	showDialog: { type: Boolean, required: true },
	actualSubProjectId: { type: String, required: true },
	spinnerRuns: { type: Boolean, require: true },
	isToAssessment: { type: Boolean, require: true },
})

import warningBlock from "./warningBlock.vue"
let warnings = ref([] as string[])

//ids
const selectedProjectId = ref<string | undefined>(undefined)
const selectedSubProjectId = ref<string | undefined>(undefined)
const selectedAssessmentId = ref<string | undefined>(undefined)
const selectedDestProjectId = ref<string | undefined>(undefined)
const selectedDestSubProjectId = ref<string | undefined>(undefined)
const selectedDestAssessmentId = ref<string | undefined>(undefined)

//lists
const projectList = ref([] as Project[])
const subProjectList = ref([] as SubProject[])
const assessmentList = ref([] as Assessment[])
const projectDestList = ref([] as Project[])
const subProjectDestList = ref([] as SubProject[])
const assessmentDestList = ref([] as Assessment[])

//flags
const loadingDestSelectionDefault = ref<boolean>(false)
const loadingSelectionDefault = ref<boolean>(false)
const copyToAssessmentCheck = ref<boolean>(false)
const copyToAssessment = ref<boolean>(false)
const moveToAssessment = ref<boolean>(false)
const saveAttempted = ref<boolean>(false)
//refs
interface PrimeVueDropdownInstance {
	$el: HTMLElement
}
const projectDropdown = ref<PrimeVueDropdownInstance | null>(null)
const subProjectDropdown = ref<PrimeVueDropdownInstance | null>(null)
const assessmentDropdown = ref<PrimeVueDropdownInstance | null>(null)
const projectDestDropdown = ref<PrimeVueDropdownInstance | null>(null)
const subProjectDestDropdown = ref<PrimeVueDropdownInstance | null>(null)
const assessmentDestDropdown = ref<PrimeVueDropdownInstance | null>(null)
const developmentStageDropdown = ref<PrimeVueDropdownInstance | null>(null)

//UI data
const newAssessmentName = ref<string | undefined>()
const selectedScreen = ref([] as Screen[])
const sourceScreen = ref([] as Screen[])
const destScreen = ref([] as Screen[])

//back end data
let projectSubProjectAssessmentTree = [] as Project[]
let availableSubProjectScreenIds = [] as string[]
let screenToDisableInUIOnCopy = [] as Screen[]

onMounted(() => {
	copyToAssessment.value = props.isToAssessment
	fillProjectList().then(() => setDefaultValues())
	const connection = new signalR.HubConnectionBuilder()
		.withUrl(VITE_API_URL + "/realtimemessaging")
		.configureLogging(signalR.LogLevel.Information)
		.build()

	connection
		.start()
		.then(() => console.log("Connected to SignalR"))
		.catch((err) => console.error("Error connecting to SignalR:", err))
	connection.on("ReceiveProgress", (progress: number, screenId: string) => {
		var toChange = screenP.value.find((item: screenPercentage) => item.screen.id === screenId)
		if (toChange !== undefined) toChange.percentage = progress
	})
	connection.on("Warnings", (warningMessage: string, screenName: string, screenId: string) => {
		console.log(warningMessage, screenName)
	})
})

const getWarnings = () => {
	let warnings = []
	warnings.push(
		"Electronic Lab Number and Assessment Comments fields will not be copied.",
		"All the other Modules are populated from source Assessment data."
	)
	if (copyToAssessment.value) {
		warnings.push(
			"You can also select which Module(s) to copy but if the target assessment already has a module (e.g. Synthetic API), you cannot copy over the existing data"
		)
	}
	return warnings
}

watch(
	() => props.isToAssessment,
	(newValue) => {
		if (newValue) {
			copyToAssessment.value = newValue
		}
	}
)
const arraysEqual = <T,>(arr1: T[], arr2: T[]): boolean => {
	if (arr1.length !== arr2.length) return false
	const sorted1 = [...arr1].sort()
	const sorted2 = [...arr2].sort()
	return sorted1.every((value, index) => value === sorted2[index])
}

const allAvailableTabs = ref([] as Screen[])

const selectedDevelopmentStage = ref<MasterDropdown>()
const developmentStageList = ref([] as MasterDropdown[])

let availableSkillAreaSubProjectToCopyTo = [] as string[]

const getAllDevelopmentStageEntries = async () => {
	try {
		const res = await apiClient.masterDropdownByCategoryKey("DevelopmentStage")
		developmentStageList.value = res
	} catch (err) {
		throw new Error(`Network response was not ddok: ${err}`)
	}
}
const emit = defineEmits<{
	(e: "cancel"): void
	(
		e: "save",
		selectedAssessmentId: string,
		actualSubProjectId: string,
		newAssessmentName: string | undefined,
		selectedDevelopmentStage: string | undefined,
		isCopyToAssessment: boolean,
		destinationAssessmentId: string | undefined,
		validScreenIds: string[],
		moveToAssessment: boolean
	): void
}>()
const save = async () => {
	if (!testFields() || props.actualSubProjectId === undefined) return
	let selectedScreensIds = selectedScreen.value.map((item) => item.id) ? selectedScreen.value.map((item) => item.id) : ([] as string[])
	if (selectedScreensIds !== undefined && selectedDevelopmentStage.value !== null) {
		const validScreenIds = selectedScreensIds.filter((id): id is string => id !== undefined)
		emit(
			"save",
			selectedAssessmentId.value!,
			props.actualSubProjectId,
			newAssessmentName.value,
			selectedDevelopmentStage.value ? selectedDevelopmentStage.value.id : undefined,
			copyToAssessment.value,
			selectedDestAssessmentId.value,
			validScreenIds,
			moveToAssessment.value
		)
		// }
	}
}
const getRowClass = (data: any) => {
	if (!copyToAssessment.value)
		return {
			background: !availableSkillAreaSubProjectToCopyTo.includes(data.id) ? "disabled-row" : "",
		}
	else return
}

const updateSelection = (value: Screen[]) => {
	if (!copyToAssessment.value) {
		if (value.map((item: any) => item.id).every((id: any) => availableSkillAreaSubProjectToCopyTo.includes(id)) || value.length === 0)
			selectedScreen.value = value
	} else {
		if (value.map((item: any) => item.id).every((id: any) => !screenToDisableInUIOnCopy.map((mapId) => mapId.id).includes(id)) || value.length === 0)
			selectedScreen.value = value
	}
}

const skillAreasInSubProject = async (subProjectId: string) => {
	try {
		const res = await apiClient.skillAreasInSubProject(subProjectId)
		availableSkillAreaSubProjectToCopyTo = res
	} catch (err) {
		throw new Error(`Network response was not ok: ${err}`)
	}
}

const getAvailableScreenForSubProject = async (assessmentId: string): Promise<string[]> => {
	try {
		const res = await apiClient.subProjectSelectedScreensIds(assessmentId)
		return res
	} catch (err) {
		throw new Error(`Network response was not ok: ${err}`)
	}
}
const resetScreenList = () => {
	allAvailableTabs.value = [] as Screen[]
	availableSubProjectScreenIds = [] as string[]
}

class screenPercentage {
	screen: Screen
	percentage: number = 0
	constructor(screen: Screen, percentage: number = 0) {
		this.screen = screen
		this.percentage = percentage
	}
}

const screenP = ref([] as screenPercentage[])
const loadingSkillAreas = ref(false)

const screenForClientAllsByTabPosition = async () => {
	loadingSkillAreas.value = true
	try {
		const res = await apiClient.screenForClientAllsByTabPosition()
		allAvailableTabs.value = res.filter(
			(screen: Screen) => !["Assessment Details", "Consumer End of Life", "LifeCycle Summary Result"].includes(screen.screenName!)
		)
		screenP.value = res.map((screen) => new screenPercentage(screen))
		loadingSkillAreas.value = false
	} catch (err: unknown) {
		loadingSkillAreas.value = false
		if (err instanceof ErrorFormat) {
			const apiError = err as any
			useErrorToaster(err)
			if (apiError.status === 409) {
				useToaster({ severity: "error", summary: "Error", detail: apiError.response?.message || apiError.message, life: 5000 })
			} else {
				throw new Error(`Error from API: ${err.message}`)
			}
		} else {
			throw new Error(`An unexpected non-Error type occurred: ${JSON.stringify(err)}`)
		}
	}
}

const updateAvailableSkillAreasInDestinationSubProject = async () => {
	if (!props.isToAssessment) {
		return true
	} //we don't have to check for a destination because it is new.

	let allSkillAreaCanBeCopied = true
	let allSkillAreasWithProblems: string[] = []
	allAvailableTabs.value.forEach((skillArea: Screen) => {
		if (skillArea.id)
			if (!availableSkillAreaSubProjectToCopyTo?.includes(skillArea.id)) {
				if (skillArea.screenName) allSkillAreasWithProblems.push(skillArea.screenName)
				skillArea.screenName = skillArea.screenName + " cannot be copied because it is not present in the target assessment."
				selectedScreen.value = selectedScreen.value.filter((item) => item.id !== skillArea.id)

				allSkillAreaCanBeCopied = false
			}
	})
	if (!allSkillAreaCanBeCopied)
		toast.add({
			severity: "warn",
			summary: "Warning",
			detail: "These screen(s) cannot be copied: " + allSkillAreasWithProblems.join(",\n") + "\ are not present in the target assessment.",
		})
}

const onAssessmentDestChange = async (event: DropdownChangeEvent) => {
	if (copyToAssessment.value && selectedDestAssessmentId.value)
		getAvailableScreenForSubProject(selectedDestAssessmentId.value!).then((res) => {
			screenForClientAllsByTabPosition()
				.then(() => {
					destScreen.value = allAvailableTabs.value.filter((item: Screen) => res.includes(item.id!) && item.isAssessmentTab)
				})

				.then(() => {
					if (copyToAssessment.value) checkIfCanBeCopiedDestination()
				})
		})
	// checkIfCanBeCopiedDestination()
}

const checkDataInAssessmentSkillAreas = async (assessmentId: string): Promise<SkillAreaStatus[]> => {
	try {
		const res = await apiClient.checkDataInAssessmentSkillAreas(assessmentId)
		return res
	} catch (err) {
		throw new Error(`Network response was not ok: ${err}`)
	}
}

const checkIfScreenIsPresent = (allStatus: SkillAreaStatus[], idToCheck: string): boolean => {
	let status = allStatus.find((singleStatus: SkillAreaStatus) => singleStatus.skillAreaId === idToCheck)
	return status?.isSkillAreaCompiled!
}

const checkIfCanBeCopiedDestination = async () => {
	if (!selectedDestAssessmentId.value || !selectedAssessmentId.value) return
	try {
		var sourceSkillAreas = await checkDataInAssessmentSkillAreas(selectedAssessmentId.value)
		var destSkillAreas = await checkDataInAssessmentSkillAreas(selectedDestAssessmentId.value!)
		var screenIdsInSourceSkillAreas = sourceSkillAreas.map((ss: SkillAreaStatus) => ss.skillAreaId)
		var screenIdsInDestSkillAreas = destSkillAreas.map((ss: SkillAreaStatus) => ss.skillAreaId)
		screenToDisableInUIOnCopy = [] as Screen[]

		allAvailableTabs.value = await apiClient.screenForClientAllsByTabPosition()

		const allowCopyWithoutModule = import.meta.env.VITE_ALLOW_COPY_TO_MODULE_WITHOUT_MODULE_ENABLED !== "false"

		allAvailableTabs.value = allAvailableTabs.value.filter((tab) => {
			const isInSource = screenIdsInSourceSkillAreas.includes(tab.id)
			const isInDest = screenIdsInDestSkillAreas.includes(tab.id)

			return allowCopyWithoutModule ? isInSource || isInDest : isInSource && isInDest
		})

		selectedScreen.value = allAvailableTabs.value

		allAvailableTabs.value.forEach((skillArea) => {
			const skillAreaId = skillArea.id!
			const isInSource = screenIdsInSourceSkillAreas.includes(skillAreaId)
			const isInDest = screenIdsInDestSkillAreas.includes(skillAreaId)
			const isPresentInDest = checkIfScreenIsPresent(destSkillAreas, skillAreaId)

			// Present in source and dest
			if (isInSource && isInDest && isPresentInDest) {
				const ispopulated = destSkillAreas.some((skill) => skill.isSkillAreaCompiled && skill.skillAreaId === skillAreaId)
				const evaluation = ispopulated && !allowCopyWithoutModule
				skillArea.screenName += evaluation ? " (already populated)" : " (already present)"
				selectedScreen.value = selectedScreen.value.filter((screen) => screen.id !== skillAreaId)
				screenToDisableInUIOnCopy.push(skillArea)
			}

			// Present in dest only
			else if (!isInSource && isInDest && isPresentInDest) {
				skillArea.screenName += " (not present in source)"
				selectedScreen.value = selectedScreen.value.filter((screen) => screen.id !== skillAreaId)
				screenToDisableInUIOnCopy.push(skillArea)
			}

			// Present in source only and not yet in dest.
			else if (isInSource && !isInDest && !isPresentInDest && allowCopyWithoutModule) {
				skillArea.screenName += " (can be added)"
			}
			// Present in source only and not yet in dest.
			else if (isInSource && !isInDest && !allowCopyWithoutModule) {
				skillArea.screenName += " (not present in dest)"
				selectedScreen.value = selectedScreen.value.filter((screen) => screen.id !== skillAreaId)
				screenToDisableInUIOnCopy.push(skillArea)
			}
		})
	} catch (err) {}
}

const onAssessmentChange = async (event: DropdownChangeEvent) => {
	if (selectedAssessmentId.value && !copyToAssessment.value)
		getAvailableScreenForSubProject(selectedAssessmentId.value)
			.then((res1) => {
				skillAreasInSubProject(props.actualSubProjectId)
				return res1
			})
			.then((res2) => {
				screenForClientAllsByTabPosition()
					.then(() => {
						allAvailableTabs.value = allAvailableTabs.value.filter((item: any) => res2.includes(item.id))
						selectedScreen.value = allAvailableTabs.value
						sourceScreen.value = allAvailableTabs.value
						if (assessmentList.value !== undefined && selectedAssessmentId.value !== undefined) {
							var oldAssessmentName = assessmentList.value.find((item: Assessment) => item.id === selectedAssessmentId.value)
							if (oldAssessmentName !== undefined)
								newAssessmentName.value =
									assessmentList!.value!.find((item: Assessment) => item.id === selectedAssessmentId!.value!)!.assessmentName! + " - Copy"
						}
					})
					.then(() => updateAvailableSkillAreasInDestinationSubProject())
					.then(() => {
						if (!copyToAssessment.value) {
							getAllDevelopmentStageEntries().then(() => {
								if (!selectedDevelopmentStage.value) developmentStageDropdown.value!.$el.click()
							})
						}
					})
			})
	else {
		if (!selectedDestProjectId.value) projectDestDropdown.value!.$el.click()
		else {
			const dropdownChangeEvent: DropdownChangeEvent = {
				originalEvent: new Event("change"),
				value: "selectedValue",
			}
			onAssessmentDestChange(dropdownChangeEvent)
		}
	}
}
const setDefaultValues = async () => {
	loadingSelectionDefault.value = true
	const dropdownChangeEvent: DropdownChangeEvent = {
		originalEvent: new Event("change"),
		value: "selectedValue",
	}
	try {
		const res = await apiClient.getSelectedProjectBySubProject(props.actualSubProjectId)
		selectedProjectId.value = res
		onProjectChange(dropdownChangeEvent)
			.then(() => {
				selectedSubProjectId.value = props.actualSubProjectId === undefined ? "" : props.actualSubProjectId
				loadingSelectionDefault.value = false
			})
			.then(() => onSubProjectChange(dropdownChangeEvent))
	} catch (err) {
		throw new Error(`Network response was not ok: ${err}`)
	}
}
const setDestDefaultValues = async () => {
	loadingDestSelectionDefault.value = true
	const dropdownChangeEvent: DropdownChangeEvent = {
		originalEvent: new Event("change"),
		value: "selectedValue",
	}
	try {
		const res = await apiClient.getSelectedProjectBySubProject(props.actualSubProjectId)
		selectedProjectId.value = res
		onProjectDestChange(dropdownChangeEvent).then(() => {
			selectedDestSubProjectId.value = props.actualSubProjectId === undefined ? "" : props.actualSubProjectId
			loadingDestSelectionDefault.value = false
		})
		// .then(() => onSubProjectDestChange(dropdownChangeEvent))
	} catch (err) {
		throw new Error(`Network response was not ok: ${err}`)
	}
}

const fillProjectList = async () => {
	try {
		const res = await apiClient.projectSubProjectAssessmentTree()
		projectSubProjectAssessmentTree = res
		projectList.value = res
		projectDestList.value = res
	} catch (err) {
		throw new Error(`Network response was not ok: ${err}`)
	}
}
const onProjectDestChange = async (event: DropdownChangeEvent) => {
	let selectedProject = projectSubProjectAssessmentTree.find((item: Project) => item.id == selectedDestProjectId.value && item.isActive === true)
	subProjectDestList.value = selectedProject?.subProject ?? []
	selectedDestAssessmentId.value = undefined
	selectedDestSubProjectId.value = undefined
	resetScreenList()
	subProjectDestDropdown.value!.$el.click()
}
const onProjectChange = async (event: DropdownChangeEvent) => {
	let selectedProject = projectSubProjectAssessmentTree.find((item: Project) => item.id == selectedProjectId.value && item.isActive === true)
	subProjectList.value = selectedProject?.subProject ?? []

	selectedAssessmentId.value = undefined
	selectedSubProjectId.value = undefined
	newAssessmentName.value = undefined
	selectedDevelopmentStage.value = undefined
	resetScreenList()
	subProjectDropdown.value!.$el.click()
}
const onSubProjectDestChange = (event: DropdownChangeEvent) => {
	let selectedSubProject = subProjectDestList.value.find((item: SubProject) => item.id == selectedDestSubProjectId.value && item.isActive === true)
	assessmentDestList.value =
		selectedSubProject !== undefined ? selectedSubProject.assessment?.sort((a, b) => a.assessmentName!.localeCompare(b.assessmentName!)) : null
	selectedDestAssessmentId.value = ""
	assessmentDestDropdown.value!.$el.click()
}
const onSubProjectChange = (event: DropdownChangeEvent) => {
	let selectedSubProject = subProjectList.value.find((item: SubProject) => item.id == selectedSubProjectId.value && item.isActive === true)
	assessmentList.value =
		selectedSubProject !== undefined ? selectedSubProject.assessment?.sort((a, b) => a.assessmentName!.localeCompare(b.assessmentName!)) : null
	selectedAssessmentId.value = ""
	newAssessmentName.value = ""
	selectedDevelopmentStage.value = undefined
	resetScreenList()
	assessmentDropdown.value!.$el.click()
}

const getSelectedSubProjectName = (selectedValue: string) => {
	const selectedSubProject = subProjectList.value.find((item: SubProject) => item.id === selectedValue)
	return selectedSubProject ? selectedSubProject.subProjectName : ""
}
const getSelectedDestSubProjectName = (selectedValue: string) => {
	const selectedSubProject = subProjectDestList.value.find((item: SubProject) => item.id === selectedValue)
	return selectedSubProject ? selectedSubProject.subProjectName : ""
}

function testFields() {
	var errorMessage = []
	var testError = false
	if (selectedScreen.value.length === 0) {
		errorMessage.push("Select at least one Module")
		testError = true
	}

	if ((!selectedDevelopmentStage.value || selectedDevelopmentStage.value.length === 0) && !copyToAssessment.value) {
		errorMessage.push("Development Stage")
		testError = true
	}

	if (newAssessmentName.value === "" && !copyToAssessment.value) {
		errorMessage.push("Assessment Name")
		testError = true
	}
	if (selectedProjectId.value === undefined || selectedSubProjectId.value === undefined || selectedAssessmentId.value === undefined) {
		errorMessage.push(!copyToAssessment.value ? "Assessment selection" : "Source Assessment")
		testError = true
	}

	if ((!selectedDestProjectId.value || !selectedDestSubProjectId.value || !selectedDestAssessmentId.value) && copyToAssessment.value) {
		errorMessage.push("Destination Assessment")
		testError = true
	}
	if (testError) {
		toast.add({
			severity: "error",
			summary: "Error",
			detail: "Please compile required fields: " + errorMessage.join(","),
			life: 2500,
		})
		saveAttempted.value = true
		return false
	}
	saveAttempted.value = false
	return true
}
</script>
<style scoped></style>
